'use strict';

(function() {
	angular.module('onboarding.carrier')
		.directive('cobCarrierProfileCompany', cobCarrierProfileCompany);

	cobCarrierProfileCompany.$inject = [
		'$location', '$timeout', 'subjectObserverMessagesService', 'observerService', 'sessionService',
		'carrierRegistrationService',  'carrierDocumentsService', '$stateParams', 'spinnerService'
	];

	var NOA_DOCUMENT_TYPE = 'Notice of Assigment (NOA)';
	var NOA_DOCUMENT_HEADER_INFO = 'Please upload Notice of Assigment (NOA) document';
	var NOA_DOCUMENT_UPLOADED_MESSAGE = 'You can now proceed with onboarding (registration).';

	var CORPORATION_COMPANY_TYPE = 'Corporation';
	var PARTNERSHIP_COMPANY_TYPE = 'Partnership';
	var SOLE_PROPRIETORSHIP_COMPANY_TYPE = 'Sole Proprietorship';
	var LIMITED_LIABILITY_COMPANY_TYPE = 'Limited Liability Company (LLC)';
	var COOPERATIVE_CANADA_COMPANY_TYPE = 'Cooperative (Canada)';

	var $location,
		$timeout,
		subjectObserverMessagesService,
		observerService,
		sessionService,
		carrierRegistrationService,
		carrierDocumentsService,
		spinnerService,
		subjectMessages,
		observerMessages,
		$stateParams;

	function cobCarrierProfileCompany(
		_$location_,
		_$timeout_,
		_subjectObserverMessagesService_,
		_observerService_,
		_sessionService_,
		_carrierRegistrationService_,
		_carrierDocumentsService_,
		_$stateParams_,
		_spinnerService_) {
		$timeout = _$timeout_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		sessionService = _sessionService_;
		carrierRegistrationService = _carrierRegistrationService_;
		carrierDocumentsService = _carrierDocumentsService_;
		spinnerService = _spinnerService_;
		$location = _$location_;
		$stateParams = _$stateParams_;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/carrier/profile/carrierProfileCompany.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();
			scope.carrierId = $stateParams.carrierId;
			if (!scope.carrierId) {
				scope.carrierId = -1;
			}

			scope.noaDocumentHeaderInfo = NOA_DOCUMENT_HEADER_INFO;
			scope.noaDocumentUploadedMessage = NOA_DOCUMENT_UPLOADED_MESSAGE;

			scope.tab = '';
			scope.setIsDirty = setIsDirty;
			scope.scacKeyDown = scacKeyDown;
			scope.veteranOwnedChange = veteranOwnedChange;
			scope.minorityOwnedChange = minorityOwnedChange;
			scope.certifiedByNMSDCChanged = certifiedByNMSDCChanged;
			scope.mailingAddressSameAsPhysicalAddressChange = mailingAddressSameAsPhysicalAddressChange;
			scope.remitToAddressSameAsPhysicalAddressChange = remitToAddressSameAsPhysicalAddressChange;
			scope.remitToAddressSameAsMailingAddressChange = remitToAddressSameAsMailingAddressChange;
			scope.factoringCompanyChange = factoringCompanyChange;

			scope.validateCompanyTypeField = validateCompanyTypeField;
			scope.validateYearFoundedField = validateYearFoundedField;
			scope.validateScacField = validateScacField;
			scope.validateRemitToNameField = validateRemitToNameField;

			scope.onForceGo = onForceGo;
			scope.saveData = saveData;
			scope.goToTab = goToTab;
			scope.uploadNoaFile = uploadNoaFile;
			scope.deleteNoaFile = deleteNoaFile;

			scope.ux_requirement_hack_for_scrolling = false;

			scope.m = {
				isDirty: false,
				isBroker: sessionService.isBroker(),
				isAdmin: sessionService.isAuthorizedInternalAdmin(),
				mailingAddressSameAsPhysicalAddress: true,
				remitToAddressSameAsPhysicalAddress: true,
				remitToAddressSameAsMailingAddress: false,
				factoringCompanyDocuments: []
			};

			scope.companyTypesDic = createCompanyTypesDic();

			scope.companyTypes = [
				CORPORATION_COMPANY_TYPE,
				LIMITED_LIABILITY_COMPANY_TYPE,
				SOLE_PROPRIETORSHIP_COMPANY_TYPE,
				PARTNERSHIP_COMPANY_TYPE,
				COOPERATIVE_CANADA_COMPANY_TYPE
			];

			scope.minorityTypes = {
				' ': ' ', // using blank makes 2 options once selected
				'AsianPacific': 'Asian Pacific',
				'AfricanAmerican': 'African American',
				'Hispanic': 'Hispanic',
				'AsianIndianAmerican': 'Asian-Indian American',
				'NativeAmericanIndian': 'Native American Indian'
			};
			registerObserverHandlers();
			loadData();
			document.title = 'Profile-Company';

			$timeout(function() {
				observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_CARRIER_PROFILE_VIEW_LOAD);
			},
			100);

		}

		function createCompanyTypesDic() {
			var companyTypesDic = {};
			companyTypesDic[CORPORATION_COMPANY_TYPE] = 'Corporation';
			companyTypesDic[PARTNERSHIP_COMPANY_TYPE] = 'Partnership';
			companyTypesDic[SOLE_PROPRIETORSHIP_COMPANY_TYPE] = 'SoleProprietorship';
			companyTypesDic[LIMITED_LIABILITY_COMPANY_TYPE] = 'LimitedLiabilityCompanyLLC';
			companyTypesDic[COOPERATIVE_CANADA_COMPANY_TYPE] = 'CooperativeCanada';

			return companyTypesDic;
		}

		function registerObserverHandlers() {
			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_START_CHANGE_CARRIER_PROFILE_VIEW, handler: saveData },
					{ message: observerMessages.COB_OBSERVER_CARRIER_PROFILE_VIEW_IS_DIRTY, handler: setIsDirty },
					{ message: observerMessages.COB_OBSERVER_SET_PENDING_TAB, handler: setPendingTab }
				]);

			scope.$on('$destroy',
				function() {
					window.onbeforeunload = undefined;
				});

			scope.$on('$locationChangeStart',
				function(event) {
					if (scope.m.isDirty) {
						if (!scope.ux_requirement_hack_for_scrolling) {
							if (!
							confirm('You have unsaved data. If you leave this page any changes will be lost. Changes are saved using the Save buttons at the bottom of the page. Are you sure you want to leave the page?')) {
								event.preventDefault();
							}
						}
					}
					scope.ux_requirement_hack_for_scrolling = false;
				});
		}

		function factoringCompanyChange() {
			scope.m.remitToName = null;
			scope.m.remitToAddress = {};
			scope.m.remitToNameError = '';
			scope.m.factoringCompanyDocumentError = '';
			scope.m.remitToAddressSameAsMailingAddress = false;
			scope.m.remitToAddressSameAsPhysicalAddress = false;
			setIsDirty();
		}

		function setIsDirty() {
			scope.m.isDirty = true;
			window.onbeforeunload = function() {
				return 'You have unsaved data. If you leave this page any changes will be lost. Changes are saved using the Save buttons at the bottom of the page.';
			};
		}

		function loadData() {
			carrierRegistrationService.lookupCarrierCompanyInfo(scope.carrierId)
				.then(function(response) {
					scope.m.certificationNumber = response.data.certificationNumber;
					scope.m.certifiedByNMSDC = response.data.certifiedByNMSDC;

					scope.m.compnayName = response.data.compnayName;
					scope.m.status = response.data.status;
					scope.m.companyType = getCompanyType(response.data.companyType);
					scope.m.disabaledVeteranOwned = response.data.disabaledVeteranOwned;
					if (response.data.minorityType === 'NotMinorityOwned') {
						scope.m.minorityType = ' ';
					} else {
						scope.m.minorityType = response.data.minorityType;
					}

					if (response.data.minorityOwned) {
						scope.m.minorityOwned = response.data.minorityOwned;
					} else {
						scope.m.minorityOwned = false;
					}

					scope.m.nameOfRegionalCouncil = response.data.nameOfRegionalCouncil;

					scope.m.scac = response.data.scac;
					scope.m.veteranOwned = response.data.veteranOwned;
					scope.m.womanOwned = response.data.womanOwned;

					if (response.data.yearFounded > 0)
						scope.m.yearFounded = response.data.yearFounded;

					if (response.data.physicalAddress) {
						scope.m.physicalAddress = response.data.physicalAddress;
					} else {
						scope.physicalAddress = {};
					}

					scope.m.mailingAddressSameAsPhysicalAddress = response.data.mailingAddressSameAsPhysicalAddress;
					if (!response.data.mailingAddressSameAsPhysicalAddress) {
						if (response.data.mailingAddress) {
							scope.m.mailingAddress = response.data.mailingAddress;
						} else {
							scope.m.mailingAddress = {};
						}
					} else {
						scope.m.mailingAddress = {};
					}
					scope.m.remitToAddressSameAsMailingAddress = response.data.remitToAddressSameAsMailingAddress;
					scope.m.remitToAddressSameAsPhysicalAddress = response.data.remitToAddressSameAsPhysicalAddress;
					if (!scope.m.remitToAddressSameAsMailingAddress && !scope.m.remitToAddressSameAsPhysicalAddress) {
						if (response.data.remitToAddress) {
							scope.m.remitToName = response.data.remitToName;
							scope.m.remitToAddress = response.data.remitToAddress;
						} else {
							scope.m.remitToAddress = {};
						}
					} else {
						scope.m.remitToAddress = {};
					}

					scope.m.interestInQuickPay = response.data.quickPay;
					scope.m.factoringCompany = response.data.factoringCompany;
					scope.m.isDirty = false;
					window.onbeforeunload = undefined;

					loadDocuments();
				})
				.catch(function(e) {
					console.log(e);
				});
		}

		function getCompanyType(companyType) {
			return Object.keys(scope.companyTypesDic)
				.find(function (key) {
					return scope.companyTypesDic[key] === companyType;
				});
		}

		function loadDocuments() {
			carrierRegistrationService.lookupCarrierDocuments(scope.carrierId).then(function (response) {
				var documents = response.data.documents;
				scope.m.factoringCompanyDocuments = carrierDocumentsService.getDocumentsByType(documents, NOA_DOCUMENT_TYPE);
			});
		}

		function scacKeyDown(event) {
			var charCode = (event.which) ? event.which : event.keyCode;
			var key = event.keyCode;

			switch (charCode) {
			case 8: //backspace
			case 35: //end
			case 36: //home
			case 37: //left arrow
			case 39: //right arrow
			case 46: //delete
				return;
			}

			// If the keys include the TAB, CTRL, SHIFT, ALT, or META keys, 10 key pad, or the arrow keys, do nothing.
			// This lets us support copy and paste too
			if ((key === 91) ||
            (15 < key && key < 19) ||
            (37 <= key && key <= 40) ||
            (key === 9) ||
            (96 <= key && key <= 105)) {
				return;
			}

			//comma
			if ((key === 188)) {
				return;
			}
			if (!/^[a-z ]+$/i.test(String.fromCharCode(charCode))) {
				event.preventDefault();
			}
		}

		function goToTab(tab) {
			observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_SET_PENDING_TAB, tab);
			observerService.sendMessageToSubject(scope,
				subjectMessages.COB_SUBJECT_START_CHANGE_CARRIER_PROFILE_VIEW,
				navigate);
		}

		function setPendingTab(tab) {
			scope.tab = tab;
		}

		function navigate() {
			observerService.sendMessageToSubject(scope,
				subjectMessages.COB_SUBJECT_FINISH_CHANGE_CARRIER_PROFILE_VIEW,
				scope.tab);
		}

		function onForceGo() {
			if (typeof (scope.pendingCallback) === 'function')
				scope.pendingCallback();
		}

		function saveData(callback, isRecursive) {
			// Brokers cannot save data.
			if (scope.m.isDirty && !scope.m.isBroker) {
				if (!isRecursive) {
					validateAddresses();
				}
				if (scope.m.physicalAddressIsValid === null ||
                    scope.m.mailingAddressIsValid === null ||
                    scope.m.remitToAddressIsValid === null) {
					$timeout(function() { saveData(callback, true); }, 100);

					return;
				}
				if (validateForm()) {
					if (scope.m.remitToAddressSameAsPhysicalAddress || scope.m.remitToAddressSameAsMailingAddress) {
						scope.m.remitToName = null;
					}
					carrierRegistrationService.updateCarrierCompanyInfo(scope.carrierId,
						scope.companyTypesDic[scope.m.companyType],
						scope.m.yearFounded,
						scope.m.scac,
						scope.m.womanOwned,
						scope.m.veteranOwned,
						scope.m.disabaledVeteranOwned,
						scope.m.minorityOwned,
						scope.m.minorityType,
						scope.m.certifiedByNMSDC,
						scope.m.nameOfRegionalCouncil,
						scope.m.certificationNumber,
						scope.m.physicalAddress,
						scope.m.mailingAddressSameAsPhysicalAddress,
						scope.m.mailingAddress,
						scope.m.remitToAddressSameAsPhysicalAddress,
						scope.m.remitToAddressSameAsMailingAddress,
						scope.m.remitToName,
						scope.m.remitToAddress,
						scope.m.interestInQuickPay,
						scope.m.factoringCompany)
						.then(function() {
							scope.m.isDirty = false;
							window.onbeforeunload = undefined;
							observerService
								.sendMessageToSubject(scope,
									subjectMessages.COB_SUBJECT_CARRIER_PROFILE_VIEW_STATUS,
									'company');
							if (typeof (callback) === 'function')
								callback();
						});
				} else {
					scope.pendingCallback = callback;
					scope.showSectionMessage = true;

					$timeout(function() {
						scope.ux_requirement_hack_for_scrolling = true;
						$('.profile-company')
							.animate({
								scrollTop: $('#error-summary').offset().top
							},
							200);
						setIsDirty();
					},
					1);

				}
			} else {
				if (typeof (callback) === 'function')
					callback();
			}
		}

		function veteranOwnedChange() {
			if (!scope.m.veteranOwned) {
				scope.m.disabaledVeteranOwned = false;
			}
		}

		function minorityOwnedChange() {
			if (!scope.m.minorityOwned) {
				scope.m.minorityType = ' ';
				scope.m.certifiedByNMSDC = false;
				certifiedByNMSDCChanged();
			}
		}

		function certifiedByNMSDCChanged() {
			if (!scope.m.certifiedByNMSDC) {
				scope.m.nameOfRegionalCouncil = '';
				scope.m.certificationNumber = '';
			}
		}

		function mailingAddressSameAsPhysicalAddressChange() {
			if (scope.m.mailingAddressSameAsPhysicalAddress) {
				scope.m.mailingAddress = {};
				if (scope.m.remitToAddressSameAsMailingAddress) {
					scope.m.remitToAddressSameAsPhysicalAddress = true;
					scope.m.remitToAddressSameAsMailingAddress = false;
				}
			}
		}

		function remitToAddressSameAsPhysicalAddressChange() {
			if (scope.m.remitToAddressSameAsPhysicalAddress) {
				scope.m.remitToAddress = {};
				scope.m.remitToAddressSameAsMailingAddress = false;
				scope.m.remitToNameError = '';
				scope.m.remitToName = '';
			}
		}

		function remitToAddressSameAsMailingAddressChange() {
			if (scope.m.remitToAddressSameAsMailingAddress) {
				scope.m.remitToAddress = {};
				scope.m.remitToAddressSameAsPhysicalAddress = false;
				scope.m.remitToNameError = '';
				scope.m.remitToName = '';
			}
		}

		function validateForm() {

			validateCompanyTypeField();
			validateYearFoundedField();
			validateScacField();
			validateRemitToNameField();
			validateQuikPayField();
			validateFactoringCompanyField();
			validateFactoringCompanyDocument();

			var isValid = isFormValid();
			if (isValid) {
				scope.showSectionMessage = false;
			}

			return isValid;
		}

		function isFormValid() {
			return !scope.m.companyTypeError && !scope.m.yearFoundedError && !scope.m.scacError &&
                scope.m.physicalAddressIsValid && scope.m.mailingAddressIsValid && scope.m.remitToAddressIsValid &&
                !scope.m.remitToNameError & !scope.m.QuikPayError && !scope.m.factoringCompanyError && !scope.m.factoringCompanyDocumentError;
		}

		function validateAddresses() {
			scope.m.physicalAddressIsValid = null;
			if (!scope.m.mailingAddressSameAsPhysicalAddress)
				scope.m.mailingAddressIsValid = null;
			else
				scope.m.mailingAddressIsValid = true;

			if (!scope.m.remitToAddressSameAsMailingAddress && !scope.m.remitToAddressSameAsPhysicalAddress)
				scope.m.remitToAddressIsValid = null;
			else
				scope.m.remitToAddressIsValid = true;
		}

		function validateCompanyTypeField() {
			if (!scope.m.companyType) {
				scope.m.companyTypeError = 'Please select an option';
			} else {
				scope.m.companyTypeError = '';
			}
		}

		function validateYearFoundedField() {
			if (typeof scope.m.yearFounded === 'string') {
				if (!scope.m.yearFounded ||
                    !scope.m.yearFounded.match(/^(?:19|20)\d{2}$/)) {
					scope.m.yearFoundedError = 'Valid input is required';

					return;
				}

				scope.m.yearFounded = parseInt(scope.m.yearFounded);
			}
			if (scope.m.yearFounded > new Date().getFullYear()) {
				scope.m.yearFoundedError = 'Valid input is required';

				return;
			}
			scope.m.yearFoundedError = '';
		}

		function validateScacField() {
			if (scope.m.scac) {
				if (!scope.m.scac.match(/^[a-zA-Z]{2,4}(,\s?[a-zA-Z]{2,4})*$/)) {
					scope.m.scacError = 'Valid input is required';

					return;
				}
			}
			scope.m.scacError = '';
		}

		function validateRemitToNameField() {
			if (!scope.m.remitToAddressSameAsMailingAddress &&
                !scope.m.remitToAddressSameAsPhysicalAddress &&
                scope.m.factoringCompany &&
                !scope.m.remitToName) {
				scope.m.remitToNameError = 'Valid input is required.';
			} else {
				scope.m.remitToNameError = '';
			}
		}

		function validateQuikPayField() {
			if (typeof (scope.m.interestInQuickPay) === 'boolean') {
				scope.m.QuikPayError = '';
			} else {
				scope.m.QuikPayError = 'Please select an option.';
			}
		}

		function validateFactoringCompanyField() {
			if (typeof (scope.m.factoringCompany) === 'boolean') {
				scope.m.factoringCompanyError = '';
			} else {
				scope.m.factoringCompanyError = 'Please select an option.';
			}
		}

		function validateFactoringCompanyDocument() {
			scope.m.factoringCompanyDocumentError = '';

			if (!scope.m.factoringCompany) {
				return;
			}

			if (!scope.m.factoringCompanyDocuments || scope.m.factoringCompanyDocuments.length === 0) {
				scope.m.factoringCompanyDocumentError = 'Document upload is mandatory. Please make sure to attach your Notice of Assignment (NOA).';
			}
		}

		function uploadNoaFile(file) {
			if (!file) {
				return;
			}

			var validationResult = carrierDocumentsService.validateFile(file);
			if (!validationResult.succeeded) {
				scope.m.factoringCompanyUploadResult = validationResult;

				return;
			}

			uploadFile(file, NOA_DOCUMENT_TYPE);
		}

		function uploadFile(file, type) {
			spinnerService.startSpinner(scope);

			carrierDocumentsService.getBase64DataUrl(file).then(function (url) {
				var documentFile = {
					documentName: file.name,
					mimeType: file.type,
					documentType: type,
					description: '',
					base64: url.split(',')[1]
				};

				carrierDocumentsService.uploadDocument(documentFile, scope.carrierId).then(function (response) {
					if (response.data.isSuccess) {
						if (type === NOA_DOCUMENT_TYPE) {
							scope.m.factoringCompanyDocuments.unshift(response.data.document);
							scope.m.factoringCompanyUploadedRecently = true;
							scope.m.factoringCompanyUploadResult = carrierDocumentsService.getResult(true);
							scope.m.factoringCompanyDocumentError = '';
							setIsDirty();
						}
					}
				}).finally(function () {
					spinnerService.stopSpinner(scope);
				});
			});
		}

		function deleteNoaFile(file) {
			scope.m.factoringCompanyUploadedRecently = false;
			scope.m.factoringCompanyUploadResult = {};
			setIsDirty();
		}
	}

})();
